import React from "react";

// reactstrap components
import {
  CardHeader,
  CardBody,
  Form,
  Container,
  Col,
  Row
} from "reactstrap";

// core components
import PartenairesNavbar from "components/Navbars/PartenairesNavbar.js";
import TransparentFooter from "components/Footers/TransparentFooter.js";

function Partenaires() {
  const [firstFocus, setFirstFocus] = React.useState(false);
  const [lastFocus, setLastFocus] = React.useState(false);
  React.useEffect(() => {
    document.body.classList.add("partenaires-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("partenaires-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);
  return (
    <>
      <PartenairesNavbar />
      <div className="page-header clear-filter" filter-color="blue">
        <div
          className="page-header-image"
          style={{
            backgroundImage:
              "url(" + require("assets/img/partenaire.jpg").default + ")",
          }}
        ></div>
        <div className="content">
          <Container>
            <Col>
{/*               <Card className="card-login card-plain"> */}
               {/*  <Form action="" className="form" method="">
                  <CardHeader className="text-center"> */}
{/*                     <div className="logo-container">
                      <img
                        alt="..."
                        src={require("assets/img/logo-nuit.png").default}
                      ></img>
                    </div> */}
                {/*   </CardHeader>
                  <CardBody> */}
                  <Row>
                    <Col className="ml-auto mr-auto">
                      {/* <p className="category">Groupe Renault</p> */}
                      <img                        
                        style={{maxWidth: "10em"}}
                        alt="..."
                        className="rounded"
                        src={require("assets/img/groupe-renault.png").default}
                      ></img>
                    </Col>
{/*               <Col sm="2">
                <p className="category">Entreprise</p>
                <img
                  alt="..."
                  className="rounded"
                  src={require("assets/img/entreprise.jpg").default}
                ></img>
              </Col> */}
            </Row>
            <p></p>
            Prenez part vous aussi à cette grande aventure en devenant partenaire privilégié du Gala.
            <br></br>
            En soutenant le Gala de l’INSA HDF, vous bénéficierez d'une image prestigieuse auprès
            d'un large public, des nouveaux diplômés ainsi qu'auprès des diplômés de demain. Nuit
            INSA met à votre disposition différents supports de communication : le programme de la
            soirée qui sera distribué à tous les invités, le billet, l'affiche de la soirée ainsi que le site web.
            Pour nous parrainer ou obtenir toute information n'hésitez pas à contacter notre équipe
            sponsor à l'adresse suivante :
            <br></br>
            <p><strong><a href="mailto:sponsor.galaensiame@gmail.com">nuitinsa.sponsor@gmail.com</a></strong></p>
            Merci à la Cité des Congrès de Valenciennes de nous accueillir encore une fois pour cet
            événement exceptionnel !
            <br></br>
            <br></br>
            <Row>
              <Col className="ml-auto mr-auto" md="3">
                <img
                  alt="cité des congrès de Valenciennes"
                  className="rounded"
                  src={require("assets/img/cite-DCV.png").default}
                ></img>
              </Col>
            </Row>
            <br></br>
            Nos partenaires actuels sont les suivants : 
            <br></br>
            <br></br>
            <Row>
              <Col className="ml-auto mr-auto" md="3">
                <img
                  style={{maxWidth: "10em"}}
                  alt="expleo"
                  className="rounded"
                  src={require("assets/img/expleo.png").default}
                ></img>
              </Col>
            </Row>
            <br></br>
            <br></br>
            <br></br>
                 {/*  </CardBody> */}
                 {/*  <CardFooter className="text-center">
                    <Button
                      block
                      className="btn-round"
                      color="info"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                      size="lg"
                    >
                      Get Startedeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee
                    </Button>
                    <div className="pull-left">
                      <h6>
                        <a
                          className="link"
                          href="#pablo"
                          onClick={(e) => e.preventDefault()}
                        >
                          Create Account
                        </a>
                      </h6>
                    </div>
                    <div className="pull-right">
                      <h6>
                        <a
                          className="link"
                          href="#pablo"
                          onClick={(e) => e.preventDefault()}
                        >
                          Need Help?
                        </a>
                      </h6>
                    </div>
                  </CardFooter> */}
                {/* </Form> */}
              {/* </Card> */}
            </Col>
          </Container>
        </div>
        <TransparentFooter />
      </div>
    </>
  );
}

export default Partenaires;
